/** All WS8 view state lives in the URL (deep-linkable); updates replace the history entry. */
import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

export type UrlPatch = Record<string, string | number | boolean | null | undefined>;

export function parseIntParam(v: string | null): number | null {
  if (v == null || v.trim() === "") return null;
  const n = Number(v);
  return Number.isFinite(n) ? Math.round(n) : null;
}

export function parseIdList(v: string | null): number[] {
  if (!v) return [];
  return v.split(",").map((x) => Number(x.trim())).filter((n) => Number.isInteger(n) && n > 0);
}

export function applyPatch(prev: URLSearchParams, patch: UrlPatch): URLSearchParams {
  const next = new URLSearchParams(prev);
  for (const [k, v] of Object.entries(patch)) {
    if (v == null || v === "" || v === false) next.delete(k);
    else next.set(k, v === true ? "1" : String(v));
  }
  return next;
}

export function useUrlState() {
  const [sp, setSp] = useSearchParams();
  const set = useCallback((patch: UrlPatch) => setSp((prev) => applyPatch(prev, patch), { replace: true }), [setSp]);
  return useMemo(() => ({
    sp,
    set,
    str: (k: string) => sp.get(k),
    int: (k: string) => parseIntParam(sp.get(k)),
    flag: (k: string) => sp.get(k) === "1",
  }), [sp, set]);
}
